 export function getAvatar(name:string) {
  console.log("function called with name ", name);
  const colors = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#009688',
    '#4CAF50',
    '#FF9800',
    '#795548'
  ];

  const letter = (name || '?').trim().charAt(0).toUpperCase();

  let hash = 0;

  for (let i = 0; i < letter.length; i++) {
    hash += letter.charCodeAt(i);
  }
console.log("letter and color is  ", letter, colors[hash % colors.length]);
  return {
    letter,
    color: colors[hash % colors.length]
  };
}

